module.exports = "https://cdn.thelire.com/ins/resource/order_follow_placeholder.b8080715de29eabbbba78c1b2c9d70be.png";